module.exports = __webpack_public_path__ + "e680907916313307da81bfb695b579b3.png";


//////////////////
// WEBPACK FOOTER
// ./img/logos/patches/16x16_v3.png
// module id = 1296
// module chunks = 0 1